import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

const Accordion = ({
  title,
  children,
  defaultOpen = false,
  className = ''
}) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <div className={`border border-accent-200 rounded-lg overflow-hidden ${className}`}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-full flex items-center justify-between p-4 bg-white hover:bg-accent-50 transition-colors"
      >
        <span className="font-medium text-primary text-left">{title}</span>
        <ChevronDown
          size={20}
          className={`text-accent-500 transition-transform duration-200 ${
            isOpen ? 'rotate-180' : ''
          }`}
        />
      </button>

      <div
        className={`overflow-hidden transition-all duration-200 ${
          isOpen ? 'max-h-[1000px]' : 'max-h-0'
        }`}
      >
        <div className="p-4 bg-secondary-50 border-t border-accent-200">
          {children}
        </div>
      </div>
    </div>
  );
};

export default Accordion;
